import React, { useState } from "react";
import { createPost } from "../../api/boardApi";

const PostForm = ({ boardSlug, onClose, onCreated }) => {
  const [form, setForm] = useState({
    title: "",
    content: "",
    tags: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!boardSlug) {
      alert("⚠ 게시판이 선택되지 않았습니다.");
      return;
    }

    const payload = {
      title: form.title,
      content: form.content,
      tags: form.tags
        .split(",")
        .map((tag) => tag.trim())
        .filter((tag) => tag !== ""),
    };

    console.log("✅ 요청 대상 boardSlug:", boardSlug);
    console.log("✅ 전송할 payload:", payload);

    try {
      await createPost(boardSlug, payload); // ✅ 백엔드 호환: slug 사용
      alert("✅ 게시글이 등록되었습니다.");
      setForm({ title: "", content: "", tags: "" }); // 폼 초기화
      onCreated();  // 목록 새로고침 트리거
      onClose();    // 폼 닫기
    } catch (err) {
      console.error("❌ 게시글 등록 실패", err);
      console.log("🚨 서버 응답 내용:", err.response?.data);
      alert("등록 실패: " + (err.response?.data?.detail || err.message));
    }
  };

  return (
    <div className="p-4 border rounded shadow bg-white">
      <h2 className="text-lg font-bold mb-4">📝 새 게시글 작성</h2>
      <form onSubmit={handleSubmit} className="space-y-2">
        <input
          type="text"
          name="title"
          placeholder="제목"
          value={form.title}
          onChange={handleChange}
          className="w-full border px-2 py-1 rounded"
          required
        />
        <textarea
          name="content"
          placeholder="내용"
          value={form.content}
          onChange={handleChange}
          className="w-full border px-2 py-1 rounded h-32"
          required
        />
        <input
          type="text"
          name="tags"
          placeholder="태그 (쉼표로 구분)"
          value={form.tags}
          onChange={handleChange}
          className="w-full border px-2 py-1 rounded"
        />
        <div className="flex justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-1 bg-gray-300 rounded"
          >
            취소
          </button>
          <button
            type="submit"
            className="px-4 py-1 bg-blue-500 text-white rounded"
          >
            등록
          </button>
        </div>
      </form>
    </div>
  );
};

export default PostForm;
